import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit{

  public building: boolean = false;

  constructor() {

  }

  title = 'get-walk-in';
  ngOnInit() {
    if(window.location.href.includes('/building')) {
      this.building = true;
    }
  }
}
